(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asistente-talles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAssistant(assistant) {
    if (!assistant || assistant.dataset.initialized === 'true') return;

    assistant.dataset.initialized = 'true';

    const screens = assistant.querySelectorAll('.kyros-size-assistant__screen');
    const progressBar = assistant.querySelector('.kyros-size-assistant__progress-bar');

    const heightInput = assistant.querySelector('[data-height-input]');
    const heightOutput = assistant.querySelector('[data-height-output]');
    const weightInput = assistant.querySelector('[data-weight-input]');
    const weightOutput = assistant.querySelector('[data-weight-output]');
    const waistInput = assistant.querySelector('[data-waist-input]');
    const waistOutput = assistant.querySelector('[data-waist-output]');

    const resultTop = assistant.querySelector('[data-result-top]');
    const resultBottom = assistant.querySelector('[data-result-bottom]');
    const resultSummary = assistant.querySelector('[data-result-summary]');

    let selectedFit = 'regular';

    function showStep(stepName, progress) {
      screens.forEach(function (screen) {
        screen.classList.toggle('is-active', screen.dataset.step === stepName);
      });

      if (progressBar) {
        progressBar.style.width = progress + '%';
      }

      window.setTimeout(function () {
        assistant.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 50);
    }

    function updateRange(input, output) {
      if (!input || !output) return;

      const min = Number(input.min);
      const max = Number(input.max);
      const value = Number(input.value);
      const percentage = ((value - min) / (max - min)) * 100;

      output.textContent = input.value;

      input.style.background =
        'linear-gradient(to right,' +
        '#ffffff 0%,' +
        '#ffffff ' + percentage + '%,' +
        'rgba(255,255,255,.16) ' + percentage + '%,' +
        'rgba(255,255,255,.16) 100%)';
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(4, index));
    }

    function calculateTopSize(height, weight, fit) {
      const sizes = ['S', 'M', 'L', 'XL', 'XXL'];
      let score = 0;

      if (weight >= 105) score = 4;
      else if (weight >= 90) score = 3;
      else if (weight >= 76) score = 2;
      else if (weight >= 63) score = 1;

      if (height >= 192 && score < 4) {
        score += 1;
      } else if (height >= 182 && weight >= 82 && score < 4) {
        score += 1;
      }

      if (fit === 'adjusted') score -= 1;
      if (fit === 'oversize') score += 1;

      return sizes[clampIndex(score)];
    }

    function calculateBottomSize(waist, fit) {
      const sizes = ['S', 'M', 'L', 'XL', 'XXL'];
      let score = 0;

      if (waist >= 110) score = 4;
      else if (waist >= 100) score = 3;
      else if (waist >= 90) score = 2;
      else if (waist >= 80) score = 1;

      if (fit === 'adjusted') score -= 1;
      if (fit === 'oversize') score += 1;

      return sizes[clampIndex(score)];
    }

    updateRange(heightInput, heightOutput);
    updateRange(weightInput, weightOutput);
    updateRange(waistInput, waistOutput);

    heightInput?.addEventListener('input', function () {
      updateRange(heightInput, heightOutput);
    });

    weightInput?.addEventListener('input', function () {
      updateRange(weightInput, weightOutput);
    });

    waistInput?.addEventListener('input', function () {
      updateRange(waistInput, waistOutput);
    });

    assistant.querySelector('[data-action="start"]')?.addEventListener('click', function () {
      showStep('height', 25);
    });

    assistant.querySelector('[data-action="back-welcome"]')?.addEventListener('click', function () {
      showStep('welcome', 0);
    });

    assistant.querySelector('[data-action="continue-height"]')?.addEventListener('click', function () {
      showStep('weight', 50);
    });

    assistant.querySelector('[data-action="back-height"]')?.addEventListener('click', function () {
      showStep('height', 25);
    });

    assistant.querySelector('[data-action="continue-weight"]')?.addEventListener('click', function () {
      showStep('fit', 100);
    });

    assistant.querySelector('[data-action="back-weight"]')?.addEventListener('click', function () {
      showStep('weight', 50);
    });

    assistant.querySelectorAll('[data-fit]').forEach(function (option) {
      option.addEventListener('click', function () {
        assistant.querySelectorAll('[data-fit]').forEach(function (item) {
          item.classList.remove('is-selected');
        });

        option.classList.add('is-selected');
        selectedFit = option.dataset.fit || 'regular';
      });
    });

    assistant.querySelector('[data-action="continue-fit"]')?.addEventListener('click', function () {
      showStep('waist', 100);
    });

    assistant.querySelector('[data-action="back-fit"]')?.addEventListener('click', function () {
      showStep('fit', 75);
    });

    assistant.querySelector('[data-action="show-result"]')?.addEventListener('click', function () {
      const height = Number(heightInput?.value || 175);
      const weight = Number(weightInput?.value || 70);
      const waist = Number(waistInput?.value || 82);

      const topSize = calculateTopSize(height, weight, selectedFit);
      const bottomSize = calculateBottomSize(waist, selectedFit);

      if (resultTop) resultTop.textContent = topSize;
      if (resultBottom) resultBottom.textContent = bottomSize;

      if (resultSummary) {
        const fitLabel =
          selectedFit === 'adjusted'
            ? 'ajustado'
            : selectedFit === 'oversize'
              ? 'oversize'
              : 'regular';

        resultSummary.textContent =
          'Parte superior calculada con ' + height + ' cm, ' + weight +
          ' kg y calce ' + fitLabel + '. Parte inferior calculada con ' +
          waist + ' cm de cintura.';
      }

      showStep('result', 100);
    });

    assistant.querySelector('[data-action="restart"]')?.addEventListener('click', function () {
      if (heightInput) heightInput.value = '175';
      if (weightInput) weightInput.value = '70';
      if (waistInput) waistInput.value = '82';

      selectedFit = 'regular';

      assistant.querySelectorAll('[data-fit]').forEach(function (item) {
        item.classList.toggle('is-selected', item.dataset.fit === 'regular');
      });

      updateRange(heightInput, heightOutput);
      updateRange(weightInput, weightOutput);
      updateRange(waistInput, waistOutput);

      showStep('welcome', 0);
    });
  }

  function initializeAllAssistants() {
    document.querySelectorAll('.kyros-size-assistant').forEach(initAssistant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllAssistants);
  } else {
    initializeAllAssistants();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const assistant = event.target.querySelector('.kyros-size-assistant');

    if (assistant) {
      assistant.dataset.initialized = 'false';
      initAssistant(assistant);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compromiso-kyros"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initKyrosCommitment(section) {
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const items = section.querySelectorAll('.kyros-commitment__item');

    items.forEach(function (item) {
      const trigger = item.querySelector('.kyros-commitment__trigger');

      trigger?.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          otherItem.classList.remove('is-open');

          const otherTrigger = otherItem.querySelector(
            '.kyros-commitment__trigger'
          );

          otherTrigger?.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initializeAllKyrosCommitments() {
    document
      .querySelectorAll('.kyros-commitment')
      .forEach(initKyrosCommitment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllKyrosCommitments
    );
  } else {
    initializeAllKyrosCommitments();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.kyros-commitment');

    if (section) {
      section.dataset.initialized = 'false';
      initKyrosCommitment(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
